import { useEffect, useState } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import { fetchData, textwithImg } from './Helpers';
import { RowGrouping, TitleWrap } from "@refinitiv-ui/efx-grid/extensions";

import freeImg from '../../images/free-w.svg';
import privateImg from '../../images/private.svg';
import advancedImg from '../../images/advanced.svg';
import professionalImg from '../../images/professional.svg';
import divindendsImg from '../../images/dividends.svg';
import fundamentalsImg from '../../images/fundamentals.svg';
import industryImg from '../../images/industry-wealth.svg';
import kpiImg from '../../images/KPI-wealth.svg';
import segmentsImg from '../../images/segments-wealth.svg';
import commentImg from '../../images/comment.svg';
import regionImg from '../../images/region.svg';
import timelineImg from '../../images/timeline.svg';
import historyImg from '../../images/history.svg';

function transformData(data,type){
  const rowKeys = {
    "free": "Redistribution Public (Free-to-Air)",
    "private": "Redistribution Private",
    "advanced": "Redistribution Private ADVANCED",
    "professional": "Internal Professional"
  }
  let tData = data.filter(row => row["packageType"].trim() === rowKeys[type])
  return tData
}

function PliDropdown({wealthData}) {

  return(
    <div>
      <ef-layout className="wealth-detail-layout">
        <ef-layout flex>
          <ef-layout flex className="wealth-detail-banner">
            <ef-layout>
              <h5>{wealthData ? wealthData.regions : ""}</h5>
              <span>Region</span>
            </ef-layout>
            <ef-layout>
              <img src={regionImg} alt="Region" />
            </ef-layout>
          </ef-layout>
          <ef-layout flex className="wealth-detail-banner">
            <ef-layout>
              <h5>{wealthData ? wealthData.timelines : ""}</h5>
              <span>Timeline</span>
            </ef-layout>
            <ef-layout>
              <img src={timelineImg} alt="Timeline" />
            </ef-layout>
          </ef-layout>
          <ef-layout flex className="wealth-detail-banner">
            <ef-layout>
              <h5>{wealthData ? wealthData.history : ""}</h5>
              <span>History</span>
            </ef-layout>
            <ef-layout>
              <img src={historyImg} alt="History" />
            </ef-layout>
          </ef-layout>
        </ef-layout>
        <ef-layout className="comment-layout">
          <img src={commentImg} alt="Comment" />
          <span>Comment</span>
          <p className='commentP'>{wealthData ? wealthData.comment : ""}</p>
          <table>
            <thead>
              <tr>
                <th>Material Name</th>
                <th>Material Code</th>
              </tr>
            </thead>
            <tbody>
              {wealthData.materialName && wealthData.materialCodes && wealthData.materialName.split("\n").map((name, index) => (
                <tr key={index}>
                  <td>{name}</td>
                  <td>{wealthData.materialCodes.split("\n")[index]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ef-layout>
      </ef-layout>
    </div>
  )
}

function Disclaimer() {

  return(
    <div>
      <p className='wealth-disclaimer'><b>Coverage</b><br></br>The reports are available for all active (i.e. currently trading) companies in the Company Fundamentals database (~100,000 companies) and IBES Estimates database  (22,000+ active companies in 90 countries).
      Company Fundamentals provides data for 94K+ companies traded in more than 170+ exchanges across the globe covering 99% of the market capitalization<br></br>Note that certain data items may not be available for all companies.</p>
      <p className='wealth-disclaimer'><b>Delivery</b><br></br>LSEG Company Snapshot API endpoints allow for delivery of the data on a request and response mechanism in JSON format via REST API.</p>
      <p className='wealth-disclaimer'><b>Usage Rights</b><br></br>For redistribution to a retail professional or non-professional audience, clients must adhere to the restrictions indicated for each package. The packages are for display use only, and end users are not permitted to store our data history. Additional Use of the data outside of Display such as downloading to Excel and alerting are not permitted unless an appropriate separate license is subscribed to. Requests for functionality or data items outside the scope of the defined segmentation should be referred to your local Business Managers for review.</p>
    </div>
  )
}

function PublicPackage({wealthData, infoData}) {

  const [info,setInfo] = useState(false);
  const [showDropdown,setShowDropdown] = useState(false);
  const [showRatios,setShowRatios] = useState(false);
  const [showSnapshot,setShowSnapshot] = useState(false);

  let publicWealthData = transformData(wealthData,"free");

  useEffect(() => {
    if(info){
      const grid = document.getElementById('infoGrid');
      const styles = {
        "background-color":"#fafaff",
        textAlign: "center"
      };
      const columns = [
        { name: 'ITEM', field: 'contentType', width: 5, scalable: true },
        { name: 'PUBLIC', field: 'public', width: 5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), styles: styles },
        { name: 'Reference', field: 'link', width: 2, scalable: true, binding: textwithImg}
      ]

      function headerWithLink(text, i, e) {
        let cell = e.cell;
        let content = cell.getContent();
        if(!content || !content._myHeaderWithLink) {
          content = document.createElement("div");
          content._myHeaderWithLink = true;
          let span = content._span = document.createElement("span");
          span.style.marginRight = "5px";
          let image = content._span1 = document.createElement("img");
          image.style.position = "absolute";
          image.style.top = "10px";
          image.style.right = "5px";
          image.style.width = "38px";
          image.src = resolveImage(i);
          let span2 = content._span2 = document.createElement("span");
          span2.style.display = "block";
          span2.style.fontWeight = 400;
          content.appendChild(span);
          content.appendChild(span2);
          // content.appendChild(image);
        }

        content._span.textContent = e.columnDef.getName();
        content._span2.textContent = text;
        cell.setContent(content);
      };

      function transformData(data){
        let transformed = [];
        data.forEach(row => {
          let val = row["public"]
          if(val.endsWith("for detail)")) {
            transformed.push({
              ...row,
              link: "https://lsegroup.sharepoint.com/:x:/r/teams/WMONLINEMANAGEMENT/Shared%20Documents/General/Wealth%20Discovery%20tool%20docs/Data_Guide_LSEG_Company_Snapshot_delivered_via_APIUpdate13Feb2026%20(2).xlsx?d=w4fb27f9dc72b409faf790e8d1f8b2cfc&csf=1&web=1&e=bUJXPv"
            })
          } else {
            transformed.push({
              ...row,
              link: ""
            })
          }
        });
        return transformed;
      }

      grid.config = {
        rowHeight: 50,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: transformData(infoData)
        },
        rowGrouping: {
          groupBy: "category"
        },
        extensions: [
          new RowGrouping(),
          new TitleWrap()
        ]
      };
    }
  }, [info, infoData]);
  

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setInfo(false)}></ef-tab>
        <ef-tab label="Information" value="tab2" onClick={() => setInfo(true)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {!info &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setShowDropdown(!showDropdown)}>
            <ef-panel spacing>
              <img src={divindendsImg} alt="Dividends" />
              <span>Financial Statements</span>
              {!showDropdown && <ef-icon icon="down"></ef-icon>}
              {showDropdown && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showDropdown && <PliDropdown wealthData={publicWealthData.filter(row => row["assetType"].trim() === "Financial Statements")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowRatios(!showRatios)}>
            <ef-panel spacing>
              <img src={fundamentalsImg} alt="Fundamentals" />
              <span>Fundamental Ratios (Analytics)</span>
              {!showRatios && <ef-icon icon="down"></ef-icon>}
              {showRatios && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showRatios && <PliDropdown wealthData={publicWealthData.filter(row => row["assetType"].trim() === "Fundamental Ratios (Analytics)")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowSnapshot(!showSnapshot)}>
            <ef-panel spacing>
              <img src={industryImg} alt="Industry" />
              <span>Company Snapshot</span>
              {!showSnapshot && <ef-icon icon="down"></ef-icon>}
              {showSnapshot && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showSnapshot && <PliDropdown wealthData={publicWealthData.filter(row => row["assetType"].trim() === "Company Snapshot")[0]} />}
          <Disclaimer />
        </ef-layout>
        }
        {info && <efx-grid id="infoGrid" className="entity-grid"></efx-grid>}
      </ef-layout>
    </div>
  );
}

function PrivatePackage({wealthData, infoData}) {

  const [info,setInfo] = useState(false);
  const [showFinance,setShowFinance] = useState(false);
  const [showRatios,setShowRatios] = useState(false);
  const [showKpis,setShowKpis] = useState(false);
  const [showSegments,setShowSegments] = useState(false);
  const [showSnapshot,setShowSnapshot] = useState(false);
  
  let privateWealthData = transformData(wealthData,"private");

  useEffect(() => {
    if(info){
      const grid = document.getElementById('infoGrid');
      const styles = {
        "background-color":"#fafaff",
        textAlign: "center"
      };
      const columns = [
        { name: 'ITEM', field: 'contentType', width: 5, scalable: true },
        { name: 'PRIVATE', field: 'private', width: 5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "free"), styles: styles },
        { name: 'Reference', field: 'link', width: 2, scalable: true, binding: textwithImg}
      ]

      function transformData(data){
        let transformed = [];
        data.forEach(row => {
          let val = row["private"]
          if(val.endsWith("for detail)")) {
            transformed.push({
              ...row,
              link: "https://lsegroup.sharepoint.com/:x:/r/teams/WMONLINEMANAGEMENT/Shared%20Documents/General/Wealth%20Discovery%20tool%20docs/Data_Guide_LSEG_Company_Snapshot_delivered_via_APIUpdate13Feb2026%20(2).xlsx?d=w4fb27f9dc72b409faf790e8d1f8b2cfc&csf=1&web=1&e=bUJXPv"
            })
          } else {
            transformed.push({
              ...row,
              link: ""
            })
          }
        });
        return transformed;
      }

      function headerWithLink(text, i, e) {
        let cell = e.cell;
        let content = cell.getContent();
        if(!content || !content._myHeaderWithLink) {
          content = document.createElement("div");
          content._myHeaderWithLink = true;
          let span = content._span = document.createElement("span");
          span.style.marginRight = "5px";
          let image = content._span1 = document.createElement("img");
          image.style.position = "absolute";
          image.style.top = "10px";
          image.style.right = "5px";
          image.style.width = "38px";
          image.src = resolveImage(i);
          let span2 = content._span2 = document.createElement("span");
          span2.style.display = "block";
          span2.style.fontWeight = 400;
          content.appendChild(span);
          content.appendChild(span2);
          // content.appendChild(image);
        }

        content._span.textContent = e.columnDef.getName();
        content._span2.textContent = text;
        cell.setContent(content);
      };
      
      grid.config = {
        rowHeight: 50,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: transformData(infoData)
        },
        rowGrouping: {
          groupBy: "category"
        },
        extensions: [
          new RowGrouping(),
          new TitleWrap()
        ]
      };
    }
  }, [info, infoData]);

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setInfo(false)}></ef-tab>
        <ef-tab label="Information" value="tab2" onClick={() => setInfo(true)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {!info &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setShowFinance(!showFinance)}>
            <ef-panel spacing>
              <img src={divindendsImg} alt="Dividends" />
              <span>Financial Statements</span>
              {!showFinance && <ef-icon icon="down"></ef-icon>}
              {showFinance && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showFinance && <PliDropdown wealthData={privateWealthData.filter(row => row["assetType"].trim() === "Financial Statements")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowRatios(!showRatios)}>
            <ef-panel spacing>
              <img src={fundamentalsImg} alt="Fundamentals" />
              <span>Fundamental Ratios (Analytics)</span>
              {!showRatios && <ef-icon icon="down"></ef-icon>}
              {showRatios && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showRatios && <PliDropdown wealthData={privateWealthData.filter(row => row["assetType"].trim() === "Fundamental Ratios (Analytics)")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowKpis(!showKpis)}>
            <ef-panel spacing>
              <img src={kpiImg} alt="KPI" />
              <span>KPI</span>
              {!showKpis && <ef-icon icon="down"></ef-icon>}
              {showKpis && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showKpis && <PliDropdown wealthData={privateWealthData.filter(row => row["assetType"].trim() === "KPI")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowSegments(!showSegments)}>
            <ef-panel spacing>
              <img src={segmentsImg} alt="Segments" />
              <span>Segments</span>
              {!showSegments && <ef-icon icon="down"></ef-icon>}
              {showSegments && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showSegments && <PliDropdown wealthData={privateWealthData.filter(row => row["assetType"].trim() === "Segments")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowSnapshot(!showSnapshot)}>
            <ef-panel spacing>
              <img src={industryImg} alt="Industry" />
              <span>Company Snapshot</span>
              {!showSnapshot && <ef-icon icon="down"></ef-icon>}
              {showSnapshot && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showSnapshot && <PliDropdown wealthData={privateWealthData.filter(row => row["assetType"].trim() === "Company Snapshot")[0]} />}
          <Disclaimer />
        </ef-layout>
        }
        {info && <efx-grid id="infoGrid" className="entity-grid"></efx-grid>}
      </ef-layout>
    </div>
  );
}

function AdvancedPackage({wealthData, infoData}) {

  const [info,setInfo] = useState(false);
  const [showFinance,setShowFinance] = useState(false);
  const [showRatios,setShowRatios] = useState(false);
  const [showKpis,setShowKpis] = useState(false);
  const [showSegments,setShowSegments] = useState(false);
  const [showSnapshot,setShowSnapshot] = useState(false);

  let advancedWealthData = transformData(wealthData,"advanced");

  useEffect(() => {
    if(info){
      const grid = document.getElementById('infoGrid');
      const styles = {
        "background-color":"#fafaff",
        textAlign: "center"
      };
      const columns = [
        { name: 'ITEM', field: 'contentType', width: 5, scalable: true },
        { name: 'ADVANCED', field: 'advanced', width: 5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "free"), styles: styles },
        { name: 'Reference', field: 'link', width: 2, scalable: true, binding: textwithImg}
      ]

      function transformData(data){
        let transformed = [];
        data.forEach(row => {
          let val = row["advanced"]
          if(val.endsWith("for detail)")) {
            transformed.push({
              ...row,
              link: "https://lsegroup.sharepoint.com/:x:/r/teams/WMONLINEMANAGEMENT/Shared%20Documents/General/Wealth%20Discovery%20tool%20docs/Data_Guide_LSEG_Company_Snapshot_delivered_via_APIUpdate13Feb2026%20(2).xlsx?d=w4fb27f9dc72b409faf790e8d1f8b2cfc&csf=1&web=1&e=bUJXPv"
            })
          } else {
            transformed.push({
              ...row,
              link: ""
            })
          }
        });
        return transformed;
      }

      function headerWithLink(text, i, e) {
        let cell = e.cell;
        let content = cell.getContent();
        if(!content || !content._myHeaderWithLink) {
          content = document.createElement("div");
          content._myHeaderWithLink = true;
          let span = content._span = document.createElement("span");
          span.style.marginRight = "5px";
          let image = content._span1 = document.createElement("img");
          image.style.position = "absolute";
          image.style.top = "10px";
          image.style.right = "5px";
          image.style.width = "38px";
          image.src = resolveImage(i);
          let span2 = content._span2 = document.createElement("span");
          span2.style.display = "block";
          span2.style.fontWeight = 400;
          content.appendChild(span);
          content.appendChild(span2);
          // content.appendChild(image);
        }

        content._span.textContent = e.columnDef.getName();
        content._span2.textContent = text;
        cell.setContent(content);
      };
      
      grid.config = {
        rowHeight: 50,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: transformData(infoData)
        },
        rowGrouping: {
          groupBy: "category"
        },
        extensions: [
          new RowGrouping(),
          new TitleWrap()
        ]
      };
    }
  }, [info, infoData]);

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setInfo(false)}></ef-tab>
        <ef-tab label="Information" value="tab2" onClick={() => setInfo(true)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {!info &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setShowFinance(!showFinance)}>
            <ef-panel spacing>
              <img src={divindendsImg} alt="Dividends" />
              <span>Financial Statements</span>
              {!showFinance && <ef-icon icon="down"></ef-icon>}
              {showFinance && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showFinance && <PliDropdown wealthData={advancedWealthData.filter(row => row["assetType"].trim() === "Financial Statements")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowRatios(!showRatios)}>
            <ef-panel spacing>
              <img src={fundamentalsImg} alt="Fundamentals" />
              <span>Fundamental Ratios (Analytics)</span>
              {!showRatios && <ef-icon icon="down"></ef-icon>}
              {showRatios && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showRatios && <PliDropdown wealthData={advancedWealthData.filter(row => row["assetType"].trim() === "Fundamental Ratios (Analytics)")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowKpis(!showKpis)}>
            <ef-panel spacing>
              <img src={kpiImg} alt="KPI" />
              <span>KPI</span>
              {!showKpis && <ef-icon icon="down"></ef-icon>}
              {showKpis && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showKpis && <PliDropdown wealthData={advancedWealthData.filter(row => row["assetType"].trim() === "KPI")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowSegments(!showSegments)}>
            <ef-panel spacing>
              <img src={segmentsImg} alt="Segments" />
              <span>Segments</span>
              {!showSegments && <ef-icon icon="down"></ef-icon>}
              {showSegments && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showSegments && <PliDropdown wealthData={advancedWealthData.filter(row => row["assetType"].trim() === "Segments")[0]} />}
          <ef-layout className="inner-layout" onClick={() => setShowSnapshot(!showSnapshot)}>
            <ef-panel spacing>
              <img src={industryImg} alt="Industry" />
              <span>Company Snapshot</span>
              {!showSnapshot && <ef-icon icon="down"></ef-icon>}
              {showSnapshot && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showSnapshot && <PliDropdown wealthData={advancedWealthData.filter(row => row["assetType"].trim() === "Company Snapshot")[0]} />}
        </ef-layout>
        }
        {info && <efx-grid id="infoGrid" className="entity-grid"></efx-grid>}
        <Disclaimer />
      </ef-layout>
    </div>
  );
}

function ProfessionalPackage({wealthData, infoData}) {

  const [info,setInfo] = useState(false);
  const [showDropdown,setShowDropdown] = useState(false);

  let professionalWealthData = transformData(wealthData,"professional");

  useEffect(() => {
    if(info){
      const grid = document.getElementById('infoGrid');
      const styles = {
        "background-color":"#fafaff",
        textAlign: "center"
      };
      const columns = [
        { name: 'ITEM', field: 'contentType', width: 5, scalable: true },
        { name: 'PROFESSIONAL', field: 'advanced', width: 5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "free"), styles: styles },
        { name: 'Reference', field: 'link', width: 2, scalable: true, binding: textwithImg}
      ]

      function transformData(data){
        let transformed = [];
        data.forEach(row => {
          let val = row["advanced"]
          if(val.endsWith("for detail)")) {
            transformed.push({
              ...row,
              link: "https://lsegroup.sharepoint.com/:x:/r/teams/WMONLINEMANAGEMENT/Shared%20Documents/General/Wealth%20Discovery%20tool%20docs/Data_Guide_LSEG_Company_Snapshot_delivered_via_APIUpdate13Feb2026%20(2).xlsx?d=w4fb27f9dc72b409faf790e8d1f8b2cfc&csf=1&web=1&e=bUJXPv"
            })
          } else {
            transformed.push({
              ...row,
              link: ""
            })
          }
        });
        return transformed;
      }

      function headerWithLink(text, i, e) {
        let cell = e.cell;
        let content = cell.getContent();
        if(!content || !content._myHeaderWithLink) {
          content = document.createElement("div");
          content._myHeaderWithLink = true;
          let span = content._span = document.createElement("span");
          span.style.marginRight = "5px";
          let image = content._span1 = document.createElement("img");
          image.style.position = "absolute";
          image.style.top = "10px";
          image.style.right = "5px";
          image.style.width = "38px";
          image.src = resolveImage(i);
          let span2 = content._span2 = document.createElement("span");
          span2.style.display = "block";
          span2.style.fontWeight = 400;
          content.appendChild(span);
          content.appendChild(span2);
          // content.appendChild(image);
        }

        content._span.textContent = e.columnDef.getName();
        content._span2.textContent = text;
        cell.setContent(content);
      };
      
      grid.config = {
        rowHeight: 50,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: transformData(infoData)
        },
        rowGrouping: {
          groupBy: "category"
        },
        extensions: [
          new RowGrouping(),
          new TitleWrap()
        ]
      };
    }
  }, [info, infoData]);

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setInfo(false)}></ef-tab>
        <ef-tab label="Information" value="tab2" onClick={() => setInfo(true)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {!info &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setShowDropdown(!showDropdown)}>
            <ef-panel spacing>
              <img src={industryImg} alt="Industry" />
              <span>Company Snapshot</span>
              {!showDropdown && <ef-icon icon="down"></ef-icon>}
              {showDropdown && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showDropdown && <PliDropdown wealthData={professionalWealthData.filter(row => row["assetType"].trim() === "Company Snapshot")[0]} />}
        </ef-layout>
        }
        {info && <efx-grid id="infoGrid" className="entity-grid"></efx-grid>}
        <Disclaimer />
      </ef-layout>
    </div>
  );
}

function WealthPackages() {

  const [packageLayout, setPackageLayout] = useState("free");
  const [wealthData, setWealthData] = useState([]);
  const [infoData, setInfoData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    fetchData("Wealth_Packages").then(res => {
      setWealthData(res);
      setDataLoaded(true);
    });
    fetchData("Segmentation_Overview_Fin_Stmt").then(res => {
      setInfoData(res);
      setDataLoaded(true);
    });
  }, []);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
      setPackageLayout(buttonId);
    });
    
  }, []);

  return(
    <div className='main-div wealth-packages'>
      <ef-loader class="loader" hidden={dataLoaded}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeImg} alt="Public"/>Public</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Private</ef-button>
              <ef-button id="advanced" toggles><img src={advancedImg} alt="Advanced"/>Advanced</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Professional</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {packageLayout === "free" && dataLoaded && <PublicPackage wealthData={wealthData} infoData={infoData} />}
      {packageLayout === "private" && dataLoaded && <PrivatePackage wealthData={wealthData} infoData={infoData} />}
      {packageLayout === "advanced" && dataLoaded && <AdvancedPackage wealthData={wealthData} infoData={infoData} />}
      {packageLayout === "professional" && dataLoaded && <ProfessionalPackage wealthData={wealthData} infoData={infoData} />}
    </div>
  )
}

export default WealthPackages;